export function getPriceParamsFromQuery(query) {
  const pricingParams = [
    'arrive',
    'depart',
    'adults',
    'dogs',
    'child_ages',
    'type',
    'facet',
  ]

  return Object.keys(query)
    .filter((param) => pricingParams.includes(param))
    .reduce((obj, key) => {
      obj[key] = query[key]
      return obj
    }, {})
}
